import anime from "animejs";
import Accordion from "accordion-js";
import FormValidator from "@yaireo/validator";

import BB_Header from "./header";
import BB_Archive_Product from "./archive_product";
import BB_Cart from "./cart";

import "sticksy";

export default class BB_Single_Product {
    constructor() {
        // extra desc accordion
        let accordion = jQuery(".accordion-container");
        if (accordion.length) {
            BB_Single_Product.accordion = new Accordion(".accordion-container");
        }

        BB_Single_Product.init();
    }
    static init() {
        // Product sizes
        jQuery(document).on("click", ".ob-product-sizes li", BB_Single_Product.change_size);
        jQuery(document).on("click", ".ob-cart-btn", BB_Single_Product.add_to_cart);
        jQuery(document).on(
            "click",
            ".ob-product-cart-disabled-overlay",
            BB_Single_Product.sizes_disabled_alert
        );

        // gift card page
        // BB_Single_Product.validate_gift_card_form()
        // jQuery(document).on('click', '.ob-gift-cart-btn', BB_Single_Product.add_gift_to_cart)
        BB_Single_Product.sticksy_init();

        BB_Single_Product.quantity_form();
        BB_Single_Product.simple_product();
        BB_Single_Product.flickity_gallery();
        BB_Single_Product.cross_sell_products();

        // jQuery(window).on('resize', BB_Single_Product.responsive_mobile)

        BB_Single_Product.responsive_mobile();

        setTimeout(() => {
            BB_Single_Product.refresh_layout();
        }, 400);

        jQuery(".ac-trigger").on("click", function () {
            let headersize = jQuery(".ob-product-gallery");
            headersize.attr("style", "");

            setTimeout(() => {
                headersize.css("height", headersize.outerHeight());
                BB_Single_Product.refresh_sticky();
            }, 500);
        });
        // BB_Archive_Product.init();
    }
    static clicks_init() {}
    static sticksy_init() {
        if (!BB_Single_Product.responsive_mode()) {
            BB_Single_Product.sticky_sidebar = new Sticksy(".ob-product-content", {
                topSpacing: 40,
            });
        }
    }
    static refresh_sticky() {
        if (BB_Single_Product.responsive_mode()) return;

        BB_Single_Product.sticky_sidebar.hardRefresh();
    }
    static refresh_layout() {
        let headersize = jQuery(".ob-product-gallery");
        headersize.attr("style", "");

        setTimeout(() => {
            headersize.css("height", headersize.outerHeight());
            BB_Single_Product.refresh_sticky();
        }, 700);
    }
    static change_size() {
        const $ = jQuery;
        const $this = $(this);
        const this_variation_id = $this.data("variation-id");
        const this_stock_quantity = $this.data("stock-quantity");
        const price_container = $(".ob-price");
        let variation_price = $this.closest("li").find(".ob-variation-price");

        price_container.html($(variation_price).html());

        $(".ob-product-sizes li").removeClass("ob-active");
        $this.addClass("ob-active");

        $(".ob-quantity").attr("data-stock-quantity", this_stock_quantity);
        $(".qty-single").val(1).attr("value", 1);

        $(".ob-cart-btn, .ob-gift-cart-btn").attr("data-variation-id", this_variation_id);
        $(".ob-product-cart-wrap").removeClass("ob-disabled");
        $(".ob-product-cart-disabled-overlay").addClass("ob-hidden");
    }
    static sizes_disabled_alert() {
        let $ = jQuery;

        $(".ob-product-sizes.ob-highlight").addClass("on");

        setTimeout(() => {
            $(".ob-product-sizes.ob-highlight").removeClass("on");
        }, 1000);
    }
    static quantity_form() {
        const $ = jQuery;

        $(document).on("click", ".qty-plus-single", function (e) {
            const $this = $(this);
            let $input = $(".ob-product-content-wrap").find(".qty-single");
            let val = parseInt($input.val());
            let stock_quantity = $this.closest(".ob-quantity").attr("data-stock-quantity");
            let new_val = val + 1;

            if (new_val <= stock_quantity) {
                $input.val(new_val).on("change");
                $input.attr("value", new_val);
            }
        });

        $(document).on("change", ".ob-product-content-wrap .qty-single", function (e) {
            const $this = $(this);
            let $input = $(".ob-product-content-wrap").find(".qty-single");
            let new_val = parseInt(e.target.value);

            $input.val(new_val).on("change");
            $input.attr("value", new_val);
        });

        $(document).on("click", ".qty-minus-single", function (e) {
            const $this = $(this);
            let $input = $(".ob-product-content-wrap").find(".qty-single");
            let val = parseInt($input.val());

            if (val > 1) {
                let new_val = val - 1;

                $input.val(new_val).on("change");
                $input.attr("value", new_val);
            }
        });
    }
    static add_to_cart(e) {
        e.preventDefault();
        let $this = jQuery(e.target);
        let product_id = $this.attr("data-product-id");
        let variation_id = $this.attr("data-variation-id");
        let quantity = jQuery(".ob-product-content-wrap .qty-single").val();
        if (!BB_Single_Product.is_simple_product()) {
            jQuery(".ob-product-cart").addClass("ob-disabled");
        }
        BB_Header.cart_start_loading();
        BB_Cart.start_loading();
        BB_Archive_Product.add_to_cart_ajax([product_id, variation_id, quantity], null);
    }
    static validate_gift_card_form() {
        let formId = jQuery(".ob-pwgc-form");
        var validator = new FormValidator();

        [...formId].forEach((el) => {
            el.addEventListener(
                "change",
                function (e) {
                    let result = validator.checkField(e.target);

                    console.log(result);
                },
                true
            );
        });
    }
    static add_gift_to_cart(e) {
        e.preventDefault();

        let $this = jQuery(e.target);
        let product_id = $this.data("product-id");
        let variation_id = $this.data("variation-id");

        let gift_card_to = $this.closest(".ob-product-content").find(".ob-pwgc-to").val();
        let gift_card_from = null;
        let gift_card_message = null;

        // let quantity = jQuery('.qty-single').attr('value')
        // let cart_item_data = {}
        // cart_item_data.pw_gift_card_to = 'test@email.com'
        console.log(gift_card_to.length);
        // console.log(product_id);
        // console.log(variation_id);

        jQuery(".ob-product-cart").addClass("ob-disabled");

        BB_Header.cart_start_loading();
        BB_Cart.start_loading();

        BB_Single_Product.add_gift_to_cart_ajax([product_id, variation_id], [gift_card_to]);

        // ajax refresh ob-product-content

        // quantity
        // change active stock quantity - if stock 0, change li.ob-active to .out-stock
    }
    static async add_gift_to_cart_ajax(product_data, form_data) {
        const request_body = {
            security: ajax_object.add_gift_to_cart_nonce,
            action: "add_gift_to_cart_action",
            data: product_data,
            cart_data: form_data,
        };
        const request = {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Cache-Control": "no-cache",
            },
            body: jQuery.param(request_body),
        };
        try {
            const respose = await fetch(ajax_object.ajax_url, request);
            const response_json = await respose.json();

            console.log(response_json);

            if (response_json.success) {
                BB_Cart.refresh();
            }
        } catch (err) {
            console.log(err);
        }
    }
    static is_simple_product() {
        let product_wrap = jQuery(".type-product");

        return product_wrap.hasClass("product-type-simple");
    }
    static simple_product() {
        let $ = jQuery;

        if (BB_Single_Product.is_simple_product()) $(".ob-product-cart-disabled-overlay").remove();
    }
    static flickity_gallery() {
        // product flickity
        var elem = document.querySelector(".ob-main-carousel");
        var elem_thumb = document.querySelector(".ob-thumb-carousel");

        var flkty = new Flickity(elem, {
            wrapAround: true,
            adaptiveHeight: true,
            pageDots: false,
            imagesLoaded: true,
            on: {
                ready: function (e) {
                    BB_Single_Product.refresh_layout();
                },
            },
        });
        var flkty_nav = new Flickity(elem_thumb, {
            pageDots: false,
            prevNextButtons: false,
            cellAlign: "left",
            contain: true,
            asNavFor: ".ob-main-carousel",
            imagesLoaded: true,
        });
    }
    static responsive_mode() {
        return window.innerWidth <= 770 ? true : false;
    }
    static responsive_mobile() {
        if (BB_Single_Product.responsive_mode()) {
            BB_Single_Product.responsive_product_info();
            // console.log("responsive");
            let contentHeader = jQuery(".ob-product-content-header").detach();
            contentHeader.prependTo(".product .ob-product-gallery");
            contentHeader.wrap("<div class='ob-product-content'></div>");

            let contentDesc = jQuery(".ob-short-description").detach();
            contentDesc.prependTo(".product .ob-product-cart");
        }
        // console.log(BB_Single_Product.responsive_currently);
    }
    static responsive_product_info() {}
    static cross_sell_products() {
        var cross_sell_products_wrap = document.querySelectorAll(".ob-cross-sell-products");
        cross_sell_products_wrap.forEach((element) => {
            var flickity_cross_sell_products = new Flickity(element, {
                pageDots: false,
                prevNextButtons: true,
                cellAlign: "left",
                contain: true,
                adaptiveHeight: false,
                imagesLoaded: true,
                freeScroll: true
            });
        });
    }
}
